/** Agent Store and Workflow Store are destinations, not apps with a sidebar. */

export function isAgentStorePath(pathname: string): boolean {
  return pathname === '/agent-store' || pathname.startsWith('/agent-store/')
}

export function isWorkflowStorePath(pathname: string): boolean {
  return pathname === '/workflow-store' || pathname.startsWith('/workflow-store/')
}

export function isStorePath(pathname: string): boolean {
  return isAgentStorePath(pathname) || isWorkflowStorePath(pathname)
}

export function isManageStorePath(pathname: string): boolean {
  return (
    pathname.endsWith('/manage-access') &&
    (pathname.startsWith('/monitoring/deployments/') ||
      pathname.startsWith('/monitoring/workflow-deployments/'))
  )
}